<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <h2 style="color: #000000">会员层级管理</h2>
          <!-- ADDBUTTON -->
          <div class='margin-bottom-15'>
            <Button type='primary' v-has="'userManage/userLevel/add'" @click='preAdd' icon='md-add'>{{
                $t('转会员层级')
              }}
            </Button>
          </div>
          <!-- DATA -->
          <div>
            <Table :loading='listLoading' :columns='columnsList' :data='tableData' border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ $t('转会员层级') }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" :label-width="80">
        <FormItem label='会员帐号' prop='username'>
          <Input v-model='windowAddItem.username' :placeholder="$t('请输入会员帐号,多个帐号用逗号隔开')"></Input>
        </FormItem>
        <FormItem label='转至层级' prop='toLevel'>
          <Select v-model='windowAddItem.toLevel' style='width:200px'>
            <Option :value="'1'" :key='1'>{{ $t('第一层') }}</Option>
            <Option :value="'2'" :key='2'>{{ $t('第二层') }}</Option>
            <Option :value="'3'" :key='3'>{{ $t('第三层') }}</Option>
            <Option :value="'4'" :key='4'>{{ $t('第四层') }}</Option>
            <Option :value="'5'" :key='5'>{{ $t('第五层') }}</Option>
            <Option :value="'6'" :key='6'>{{ $t('第六层') }}</Option>
            <Option :value="'7'" :key='7'>{{ $t('第七层') }}</Option>
            <Option :value="'8'" :key='8'>{{ $t('第八层') }}</Option>
            <Option :value="'9'" :key='9'>{{ $t('第九层') }}</Option>
            <Option :value="'0'" :key='0'>{{ $t('黑名单层') }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <Modal v-model="windowEdit.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowEditCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ $t('编辑') }}</span>
      </p>
      <Form ref="windowEditForm" :rules="windowEditValidate" :model="windowEditItem" :label-width="130">
        <FormItem label='备注' prop='remark'>
          <Input v-model='windowEditItem.remark' :placeholder="$t('请输入备注')"></Input>
        </FormItem>
        <FormItem label='充值总次数阈值' prop='recharge_count'>
          <Input v-model='windowEditItem.recharge_count' :placeholder="$t('请输入充值总次数阈值')"></Input>
        </FormItem>
        <FormItem label='充值总金额阈值' prop='recharge_money'>
          <Input v-model='windowEditItem.recharge_money' :placeholder="$t('请输入充值总金额阈值')"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowEditCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowEditSubmit" :loading="windowEdit.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->
  </div>
</template>
<script>
import {
  getList,
  add,
  edit,
  changeStatus
} from '@/api/userManage/userLevel'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

export default {
  name: 'interface_list',
  data () {
    return {
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value () {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value () {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value () {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [{
        title: this.$t('层级名称'),
        key: 'level_name',

        minWidth: 80,
        align: 'center'
      }, {
        title: this.$t('层级值'),
        key: 'level_number',

        minWidth: 80,
        align: 'center'
      }, {
        title: this.$t('充值总次数阈值'),
        key: 'recharge_count',

        minWidth: 80,
        align: 'center'
      }, {
        title: this.$t('充值总金额阈值'),
        key: 'recharge_money',

        minWidth: 80,
        align: 'center'
      }, {
        title: this.$t('会员数量'),
        key: 'userNum',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('备注'),
        key: 'remark',

        minWidth: 100,
        align: 'center'
      }, {
        title: this.$t('是否限制提现'),
        align: 'center',
        width: 100,

        render: (h, params) => {
          let vm = this
          return h('i-switch', {
            attrs: {
              size: 'large'
            },
            props: {
              'true-value': 1,
              'false-value': 0,
              value: params.row.is_limit_withdraw,
              disabled: !this.buttonShow.changeStatus
            },
            on: {
              'on-change': function (status) {
                changeStatus(status, params.row.id).then(response => {
                  vm.$Message.success(response.data.msg),
                    this.getList()
                })
              }
            }
          }, [
            h('span', {
              slot: 'open'
            }, this.$t('open_choose')),
            h('span', {
              slot: 'close'
            }, this.$t('close_choose'))
          ])
        }
      }, {
        title: this.$t('操作'),
        align: 'center',
        minWidth: 150,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Button', {
            props: {
              type: 'primary'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                vm.windowEditItem.remark = params.row.remark
                vm.windowEditItem.recharge_count = params.row.recharge_count
                vm.windowEditItem.recharge_money = params.row.recharge_money
                vm.windowEditItem.id = params.row.id
                vm.windowEdit.show = true
              }
            }
          }, this.$t('编辑')), h('Poptip', {
            props: {
              confirm: true,
              title: this.$t('分层会将本层设定条件重新分层，请您确认是否分层?'),
              transfer: true
            },
            on: {
              'on-ok': () => {
                /**
                 del(params.id).then(response => {
             this.tableData.splice(index, 1)
              this.$Message.success(response.data.msg)
            })
                 params.loading = false
                 **/
              }
            }
          }, [
            h('Button', {
              style: {
                margin: '0 5px'
              },
              props: {
                type: this.$t('info'),
                placement: 'top',
                loading: params.isDeleting
              }
            }, this.$t('分层'))
          ]), h('Button', {
            props: {
              type: 'warning'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
              }
            }
          }, this.$t('设置')),])
        }
      },],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searchConf: { searchTime: [], }, // 搜索字段

      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAddItem: { //弹窗数据绑定
        id: 0
      },
      windowAddValidate: {//窗口校验规则
      }, windowEdit: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowEditItem: { //弹窗数据绑定
        id: 0
      },
      windowEditValidate: {//窗口校验规则
      },                            //----------------
    }
  },
  created () {
    let vm = this
    vm.getList()
    vm.hasRule('userManage/userLevel/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('userManage/userLevel/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('userManage/userLevel/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
  },
  methods: {
    preAdd () {
      let vm = this
      vm.windowAdd.show = true
    },
    changePage (page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize (size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search () {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList () {
      let vm = this
      vm.listLoading = true
      getList({
        page: vm.tableShow.currentPage,
        size: vm.tableShow.pageSize,
        search: vm.searchConf
      }).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange (datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({ column, key, order }) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowAddCancel (data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    }, windowAddSubmit () {
      let vm = this
      vm.$refs['windowAddForm'].validate((valid) => {
        if (valid) {
          vm.windowAdd.loading = true

          add(vm.windowAddItem).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowAddCancel()
          }).catch(() => {
            vm.windowAdd.loading = false
          })

        }
      })
    }, windowEditCancel (data) {
      if (!data) {
        this.windowEditItem.id = 0
        this.$refs['windowEditForm'].resetFields()
        this.windowEdit.show = false
        this.windowEdit.loading = false
        this.windowEdit.index = 0
      }
    }, windowEditSubmit () {
      let vm = this
      vm.$refs['windowEditForm'].validate((valid) => {
        if (valid) {
          vm.windowEdit.loading = true
          edit(vm.windowEditItem).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowEditCancel()
          }).catch(() => {
            vm.windowEdit.loading = false
          })

        }
      })
    },
  }
}
</script>
